import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PropTypes from "prop-types";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import MoreIcon2 from "@mui/icons-material/MoreVert";
import DehazeIcon from "@mui/icons-material/Dehaze";

export function ThreeLinesIcon(props) {
  return <DehazeIcon {...props} />;
}
function ExpandCollapseIcon({ isLoading = false, enableKlik = false, ...props }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    enableKlik && setIsOpen(!isOpen);
  };

  return (
    <div onClick={handleClick}>
      {isLoading && <ProgressCirc isLoading={isLoading} />}
      {!isLoading && isOpen ? (
        <ExpandMoreIcon color="primary" {...props} />
      ) : (
        <ExpandLessIcon color="primary" {...props} />
      )}
    </div>
  );
}

export default ExpandCollapseIcon;

ExpandCollapseIcon.propTypes = {
  isLoading: PropTypes.bool,
  enableKlik: PropTypes.bool,
};

export function MoreIcon(props) {
  return <MoreIcon2 {...props} />;
}
